import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkTable, SkAlertBanner } from './_primitives';

/** CMSPage — optional alert, 4 stats, 5 status tabs, campaigns table */
const CMSPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={1} />
    <SkAlertBanner />
    <SkStatCards count={4} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={5} />
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={6} inCard={false} />
      </div>
    </Card>
  </div>
);

export default CMSPageLoader;
